import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: {
    hasApproval: false,
    hideBrowserWarning: false,
  },
  error: null,
  initialLoad: false,
  loading: false,
};

const getApprovalsCheckRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getApprovalsCheckRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    initialLoad: false,
    loading: false,
  };
};
const getApprovalsCheckRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: {
      ...state.data,
      hasApproval: !!payload?.data?.hasApproval,
    },
    error: null,
    initialLoad: true,
    loading: false,
  };
};

const dismissBrowserWarning = (state) => {
  return {
    ...state,
    data: {
      ...state.data,
      hideBrowserWarning: true,
    },
  };
};

export default handleActions(
  {
    [types.GET_APPROVALS_CHECK_REQUEST]: getApprovalsCheckRequest,
    [types.GET_APPROVALS_CHECK_REQUEST_FAILURE]: getApprovalsCheckRequestFailure,
    [types.GET_APPROVALS_CHECK_REQUEST_SUCCESS]: getApprovalsCheckRequestSuccess,
    [types.DISMISS_BROWSER_WARNING]: dismissBrowserWarning,
  },
  initialState
);
